// extracted by mini-css-extract-plugin
export default {"ribbon":"ribbon__1G2T3"};